import config from "../../src/common/default_config";

export default class options extends config {
  static page_ratio = 1.4925;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static contactEditor = "";
  static helpUrl = "";
  static forgotPasswordLink = "";
  static disclaimerurl = "";
  static paywallIframeBannerSource = "";
  static kiosqueIframeBannerSource = "";
  static editor = "De Tijd";
  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "MFN",
  };
  static touchDownloadPdf = true;
  static shareFromReader = true;
  static sharingEnabled = true;
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    GooglePlus: false,
    TwitterX: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "",
  };

  //pdf
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;
  static turnOnHeaderHelp = true;
  static toggleSubscriptionTopNavButtonOnUserLoggedIn = true;
  static displayTopNavButtonlabel = true;

  static dateFormat = "D MMMM YYYY";
  static extraLinkDirectAccess = true;

  static enrichment_placement_vertical = "center";
  static enrichment_placement_horizontal = "center";

  static paywallRedirectionUrl = true;
  static externalPaywallMaxRedirectionNumber = 20;
  static urlRedirectParameter = "redirect_uri";
  static SSOEnabled = true;
  static urlSSOTokenParameter = "code";
  static getSSOTokenFromUrl = true;
  static generateSSOState = true;
}



// WEBPACK FOOTER //
// ./clients/mfn-tij/config.js